import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import swal from 'sweetalert'
import {
	appAcceptsansthaMembership,
	appDeletesansthaMembership,
	appGetAllSanstha,
	appRejctedsansthaMembership,
} from '../../store/sanstha'
import Paginate from '../../components/pagination/paginate'
import Select from 'react-select'
import { appAllGetHubs } from '../../store/hubs'
import { appPendingMembership } from '../../store/pendingmembers'
import PostPreview from '../../components/PostPreview/PostPreview'
import { toCamelCase } from '../../utils/Function'

const formatMembershipDate = value => {
	if (!value) return '-'
	const date = new Date(value)
	if (Number.isNaN(date.getTime())) return value

	const day = String(date.getDate()).padStart(2, '0')
	const month = String(date.getMonth() + 1).padStart(2, '0')
	const year = date.getFullYear()
	return `${day}-${month}-${year}`
}

const MembershipTypeDetails = ({ item }) => {
	const isUpgrade = item?.upgradeMembership && item?.previousMembershipType

	if (isUpgrade) {
		return (
			<div
				className="d-flex"
				style={{
					minWidth: '375px',
					border: '1px solid #cddced',
					borderRadius: '6px',
					overflow: 'hidden',
					backgroundColor: '#f8fbff',
				}}
			>
				<div style={{ flex: 1 }}>
					<div
						style={{
							padding: '14px 16px',
							backgroundColor: '#eef4fb',
							borderBottom: '1px solid #cddced',
							color: '#40536c',
							fontSize: '12px',
							fontWeight: 700,
							textTransform: 'uppercase',
						}}
					>
						Existing Membership
					</div>
					<div style={{ padding: '16px' }}>
						<div style={{ color: '#42566f', fontSize: '15px', fontWeight: 700 }}>
							{item?.previousMembershipType || '-'}
						</div>
						<div style={{ marginTop: '12px', color: '#61738a', fontSize: '13px', fontWeight: 600 }}>
							Start: {formatMembershipDate(item?.previousMembershipStartDate)}
						</div>
						<div style={{ marginTop: '4px', color: '#61738a', fontSize: '13px', fontWeight: 600 }}>
							End: {formatMembershipDate(item?.previousMembershipEndDate)}
						</div>
					</div>
				</div>
				<div style={{ flex: 1, borderLeft: '1px solid #cddced', backgroundColor: '#eafff4' }}>
					<div
						style={{
							padding: '14px 16px',
							backgroundColor: '#eef4fb',
							borderBottom: '1px solid #cddced',
							color: '#40536c',
							fontSize: '12px',
							fontWeight: 700,
							textTransform: 'uppercase',
						}}
					>
						Applied Membership
					</div>
					<div style={{ padding: '16px' }}>
						<div style={{ color: '#18754a', fontSize: '15px', fontWeight: 700 }}>
							{item?.membershipType || '-'}
						</div>
						<div style={{ marginTop: '12px', color: '#61738a', fontSize: '13px', fontWeight: 600 }}>
							Start: {formatMembershipDate(item?.membershipStartDate)}
						</div>
						<div style={{ marginTop: '4px', color: '#61738a', fontSize: '13px', fontWeight: 600 }}>
							End: {formatMembershipDate(item?.membershipEndDate)}
						</div>
					</div>
				</div>
			</div>
		)
	}

	return (
		<div
			style={{
				minWidth: '375px',
				border: '1px solid #cddced',
				borderRadius: '6px',
				backgroundColor: '#f8fbff',
				padding: '18px 16px',
			}}
		>
			<div style={{ color: '#61738a', fontSize: '13px', fontWeight: 700 }}>First Time Membership</div>
			<div style={{ marginTop: '14px', color: '#26384d', fontSize: '15px', fontWeight: 700 }}>
				{item?.membershipType || '-'}
			</div>
			<div style={{ marginTop: '12px', color: '#61738a', fontSize: '13px', fontWeight: 600 }}>
				Start: {formatMembershipDate(item?.membershipStartDate)}
			</div>
			<div style={{ marginTop: '4px', color: '#61738a', fontSize: '13px', fontWeight: 600 }}>
				End: {formatMembershipDate(item?.membershipEndDate)}
			</div>
		</div>
	)
}

function TableFilter({ setExportFilters }) {
	const dispatch = useDispatch()
	const navigate = useNavigate()
	// const id = useParams();
	const params = useParams()
	const [showUserModal, setShowUserModal] = useState(false)
	const [rejectionReason, setRejectionReason] = useState('')
	const [rejectionError, setRejectionError] = useState('')
	const [rejectedId, setRejectedId] = useState(null)
	const [page, setPage] = useState(params.page || 1)
	const [activeFilters, setActiveFilters] = useState({})
	const [selectedFilters, setSelectedFilters] = useState({
		sanstha: null,
		hub: null,
		startDate: null,
		endDate: null,
	})
	const [error, setError] = useState('')
	const hub = useSelector(state => state?.hubReducer.hub)
	const paginate = useSelector(state => state.PendingMembershipReducer.paginate)
	//console.log(paginate)
	const pendingMembership = useSelector(state => state.PendingMembershipReducer.pendingMembership)
	const sansthaId = localStorage.getItem('sansthaId')
	const permissionOfSanstha = localStorage.getItem('permissionOfSanstha')
	useEffect(() => {
		// dispatch(appGetAllSanstha({ page: 1, limit: 1000 }))
		dispatch(appAllGetHubs({ page: 1, limit: 1000 }))
	}, [page])
	useEffect(() => {
		const searchParams = {
			...activeFilters,
			page,
			limit: 10,
			sanstha: sansthaId || permissionOfSanstha,
		}
		dispatch(appPendingMembership(searchParams))
		navigate(`/requsteduser/${page}`)
	}, [page, activeFilters])

	const handleSearch = useCallback(() => {
		if (selectedFilters.startDate && !selectedFilters.endDate) {
			setError('Please select an end date.')
			return
		}

		setError('')
		const filters = {}
		if (selectedFilters.hub) {
			filters.hub = selectedFilters.hub.value
		}
		if (selectedFilters.sanstha) {
			filters.sanstha = selectedFilters.sanstha.value
		}
		if (selectedFilters.startDate) {
			filters.startDate = selectedFilters.startDate
		}
		if (selectedFilters.endDate) {
			filters.endDate = selectedFilters.endDate
		}
		setActiveFilters(filters)
		setExportFilters(filters)
		setPage(1)
	}, [selectedFilters])

	const handleDeletesansthaMembership = membershipId => {
		//console.log(membershipId)
		swal({
			title: 'Are you sure?',
			text: 'You want to delete this Sanstha Membership?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willDelete => {
			if (willDelete) {
				dispatch(
					appDeletesansthaMembership({
						id: membershipId,
					}),
				).then(() => {
					dispatch(
						appPendingMembership({ page: 1, limit: 10, sanstha: sansthaId || permissionOfSanstha }),
					)
				})
			}
		})
	}

	const handleRejectedsansthaMembership = id => {
		setRejectedId(id)
		setShowUserModal(true)
	}

	const handleAcceptedsansthaMembership = item => {
		//console.log(item)
		swal({
			title: 'Are you sure?',
			text: 'Are you sure you want to approve this membership request?',
			icon: 'warning',
			buttons: true,
			dangerMode: true,
		}).then(willAccept => {
			if (willAccept) {
				dispatch(appAcceptsansthaMembership({ membershipId: item?._id })).then(() => {
					dispatch(
						appPendingMembership({ page: 1, limit: 10, sanstha: sansthaId || permissionOfSanstha }),
					)
				})
			}
		})
	}

	const hnadleSubmitRected = () => {
		if (!rejectionReason.trim()) {
			setRejectionError('Reason is required.')
			return
		}
		setRejectionError('')
		dispatch(
			appRejctedsansthaMembership({
				membershipId: rejectedId,
				rejectionreason: rejectionReason,
			}),
		).then(() => {
			dispatch(
				appPendingMembership({ page: 1, limit: 10, sanstha: sansthaId || permissionOfSanstha }),
			)
		})
		setShowUserModal(false)
		setRejectionReason('')
		setRejectedId(null)
	}

	const handleCloseModal = () => {
		setShowUserModal(false)
		setRejectionReason('')
		setRejectionError('')
		setRejectedId(null)
	}

	return (
		<>
			<div className="card dataTables_wrapper">
				<div className="card-body">
					<div className="row">
						<div className="col-md-2">
							<div className="form-group">
								<label>Community</label>
								<Select
									options={
										Array.isArray(hub.data)
											? hub.data.map(hub => ({
													value: hub._id,
													label: toCamelCase(hub?.name),
											  }))
											: []
									}
									onChange={option => {
										setSelectedFilters(prev => ({
											...prev,
											hub: option,
										}))
									}}
									value={selectedFilters.hub}
									placeholder="Select Community.."
									getOptionLabel={option => option.label}
									getOptionValue={option => option.value}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>Start Date</label>
								<input
									type="date"
									className="form-control"
									value={selectedFilters.startDate || ''}
									max={new Date().toISOString().split('T')[0]}
									onChange={e => {
										const value = e.target.value
										setSelectedFilters(prev => ({
											...prev,
											startDate: value,
											endDate: prev.endDate && prev.endDate < value ? '' : prev.endDate,
										}))
									}}
								/>
							</div>
						</div>

						<div className="col-md-2">
							<div className="form-group">
								<label>End Date</label>
								<input
									type="date"
									className="form-control"
									min={selectedFilters.startDate || ''}
									max={new Date().toISOString().split('T')[0]}
									value={selectedFilters.endDate || ''}
									onChange={e => {
										const value = e.target.value
										setSelectedFilters(prev => ({
											...prev,
											endDate: value,
										}))
										if (value) setError('')
									}}
								/>
								{error && <span className="text-danger">{error}</span>}
							</div>
						</div>
						<div className="d-flex" style={{ alignItems: 'center', marginTop: '12px' }}>
							<button
								className="btn btn-primary mr-2"
								onClick={handleSearch}
								style={{ marginRight: '8px' }}
							>
								<em className="fas fa-search"></em> Search
							</button>
							<button
								className="btn btn-secondary"
								onClick={() => {
									setSelectedFilters({
										sanstha: null,
										hub: null,
										startDate: null,
										endDate: null,
									})
									setActiveFilters({})
									setExportFilters({})
									setPage(1)
								}}
							>
								<em className="fas fa-redo"></em> Reset
							</button>
						</div>
					</div>
					<div className="table-responsive">
						<table className="table table-bordered table-hover">
							<thead>
								<tr>
									<th>Community</th>
									<th>Sanstha</th>
									<th>User</th>
									<th data-column-id="sender">Mobile number </th>
									<th>Membership Type</th>
									<th>Honorary Answer</th>
									<th>Amount</th>
									<th data-column-id="received" data-order="desc">
										Documents
									</th>

									<th>Existing Member</th>
									<th data-column-id="received" data-order="desc">
										Status
									</th>
									<th data-column-id="received" data-order="desc">
										Payment Date
									</th>
									<th>Payment Reference No</th>
									<th data-column-id="commands" data-formatter="commands" data-sortable="false">
										Action
										<div></div>
									</th>
								</tr>
							</thead>
							{pendingMembership.data?.map(item => (
								<tbody>
									<tr>
										<td>
											<PostPreview value={item?.hub?.image} />
											{toCamelCase(item?.hub?.name)}
										</td>
										<td>
											{' '}
											<PostPreview value={item?.sansthaId?.image} />
											{toCamelCase(item?.sansthaId?.name)}
										</td>
										<td>
											<PostPreview value={item?.userId?.profilePic || '/img/user.jpg'} />
											{item?.userId?.firstName} {item?.userId?.lastName}
										</td>

										<td> {item?.userId?.mobile}</td>
										<td>
											<MembershipTypeDetails item={item} />
										</td>
										<td>{item?.honoraryAnswer}</td>
										<td>
											{' '}
											₹ <span style={{ fontWeight: 'bold' }}>{item?.amount}</span>
										</td>
										<td>
											{item?.paymentScreenshot && <PostPreview value={item?.paymentScreenshot} />}

											{item?.membershipCard && (
												<img
													className="ml-2"
													src={item?.membershipCard}
													alt="user"
													height={50}
													width={50}
												/>
											)}
											{item?.membershipFeeReceipt && (
												<img
													className="ml-2"
													src={item?.membershipFeeReceipt}
													alt="user"
													height={50}
													width={50}
												/>
											)}
											{item?.otherDocuments && (
												<img
													className="ml-2"
													src={item?.otherDocuments}
													alt="user"
													height={50}
													width={50}
												/>
											)}
										</td>

										<td>
											{(item?.existingMember === true || item?.existingMember === 'true') && (
												<span className="badge badge-primary">Yes</span>
											)}
											{(item?.existingMember === false || item?.existingMember === 'false') && (
												<span className="badge badge-primary">No</span>
											)}
										</td>

										<td>
											{item?.status === 'Pending' && (
												<span className="badge badge-primary">Pending</span>
											)}
											{item?.status === 'Accepted' && (
												<span className="badge badge-success">Accepted</span>
											)}
											{item?.status === 'Rejected' && (
												<span className="badge badge-danger">Rejected</span>
											)}
										</td>
										<td>{item?.paymentDate}</td>
										<td>{item?.paymentRef}</td>
										<td>
											{item.status === 'Pending' ? (
												<>
													<button
														type="button"
														className="btn btn-sm btn-green command-delete ml-1 mr-1"
														data-row-id="10253"
														onClick={() => handleAcceptedsansthaMembership(item)}
													>
														<i className="fa fa-check" aria-hidden="true">
															{' '}
															Accept
														</i>
													</button>
													<button
														type="button"
														className="btn btn-sm btn-danger command-delete"
														data-row-id="10253"
														onClick={() => handleRejectedsansthaMembership(item?._id)}
													>
														<i className="fa fa-ban" aria-hidden="true">
															{' '}
															Reject
														</i>
													</button>
												</>
											) : (
												<button
													type="button"
													className="btn btn-sm btn-danger command-delete"
													data-row-id="10253"
													onClick={() => handleDeletesansthaMembership(item?._id)}
												>
													<em className="fa fa-trash fa-fw"></em>
												</button>
											)}
										</td>
									</tr>
								</tbody>
							))}
						</table>
					</div>
					{paginate && <Paginate paginate={paginate} page={page} setPage={setPage} />}
				</div>
			</div>
			{showUserModal && (
				<div
					className="modal fade show"
					style={{
						display: 'block',
						backgroundColor: 'rgba(0,0,0,0.5)',
						top: '50px',
					}}
				>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5 className="modal-title"> Rejection </h5>
								<button type="button" className="close" onClick={handleCloseModal}>
									<span>&times;</span>
								</button>
							</div>
							<div className="modal-body">
								<div className="form-group">
									<label>Reason of rejection</label>
									<textarea
										className="form-control"
										name="description"
										value={rejectionReason}
										onChange={e => setRejectionReason(e.target.value)}
										rows="3"
									/>
									{rejectionError && (
										<div style={{ color: 'red', marginTop: '5px' }}>{rejectionError}</div>
									)}
								</div>
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
									Cancel
								</button>
								<button
									type="button"
									className="btn btn-primary"
									onClick={hnadleSubmitRected}
									// disabled={!rejectionReason.trim()}
								>
									Submit
								</button>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default TableFilter
